import {Directive, ElementRef, HostListener, Renderer2, forwardRef, Input} from '@angular/core';
import {NG_VALUE_ACCESSOR, ControlValueAccessor} from '@angular/forms';

const NUMBER_FORMATTER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => NumberFormatterDirective),
  multi: true
};

@Directive({
  selector: '[numberFormatter]',
  providers: [NUMBER_FORMATTER_VALUE_ACCESSOR]

})
export class NumberFormatterDirective implements ControlValueAccessor {

  @Input() decimalPlaces: number = 2;

  private onChange: any = () => {
  };
  private onTouched: any = () => {
  };

  private DECIMAL_SEPARATOR: string;
  private THOUSANDS_SEPARATOR: string;

  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {
    this.el = this.elementRef.nativeElement;
    this.DECIMAL_SEPARATOR = ".";
    this.THOUSANDS_SEPARATOR = ",";
  }

  @HostListener('input', ['$event']) onInput(): void {
    let inputValue: string = this.el.value.replace(/[^0-9.]/g, '');
    inputValue = this.formatInput(inputValue);
    this.setOnChange(inputValue)
    this.renderer.setProperty(this.el, 'value', inputValue);
  }

  @HostListener('blur', ['$event']) onBlur(): void {
    let inputValue: string = this.el.value;
    inputValue = this.roundToDecimal(inputValue);
    this.setOnChange(inputValue)
    this.renderer.setProperty(this.el, 'value', inputValue);
    this.onTouched();
  }

  @HostListener('focus', ['$event']) onFocus(): void {
    let inputValue: string = this.el.value;
    inputValue = this.removeTrailingZeros(inputValue);
    this.setOnChange(inputValue)
    this.renderer.setProperty(this.el, 'value', inputValue);
  }

  writeValue(value: any): void {
    if (value !== undefined && value !== null) {
      this.renderer.setProperty(this.el, 'value', this.roundToDecimal(value.toString()));
    } else {
      this.renderer.setProperty(this.el, 'value', '');
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.el, 'disabled', isDisabled);
  }

  private setOnChange(inputValue: string) {
    const numberValue = parseFloat(inputValue.replaceAll(this.THOUSANDS_SEPARATOR, ""))
    this.onChange(!isNaN(numberValue) ? numberValue : undefined);
  }

  private splitNumber(value: string) {
    const [integerPart, decimalPart] = value.split(this.DECIMAL_SEPARATOR);
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);
    return [formattedInteger, decimalPart];
  }

  private formatInput(value: string): string {
    const numberValue: number = parseFloat(value.replaceAll(this.THOUSANDS_SEPARATOR, ""));
    if (!isNaN(numberValue)) {
      const [integerPart, decimalPart] = this.splitNumber(value);
      return decimalPart !== undefined ? `${integerPart}${this.DECIMAL_SEPARATOR}${decimalPart}` : integerPart;
    } else {
      return '';
    }
  }


  private roundToDecimal(value: string): string {
    const numberValue: number = parseFloat(value.replaceAll(this.THOUSANDS_SEPARATOR, ""));
    if (!isNaN(numberValue)) {
      const [integerPart, decimalPart] = this.splitNumber(numberValue.toFixed(this.decimalPlaces))
      return `${integerPart}${this.DECIMAL_SEPARATOR}${decimalPart}`;
    } else {
      return '';
    }
  }

  private removeTrailingZeros(value: string): string {
    const [integerPart, decimalPart] = value.split(this.DECIMAL_SEPARATOR);
    if (decimalPart) {
      const formattedDecimal = decimalPart.replace(/0+$/, '');
      return formattedDecimal ? `${integerPart}${this.DECIMAL_SEPARATOR}${formattedDecimal}` : integerPart;
    } else {
      return value;
    }
  }
}
